import { getToken, getUserData } from "./auth";
import { extractVideoId } from "./youtube";
import axios from 'axios'; // 確保已安裝 axios

export async function youtbebuToText(url) {
    try {
        const result = await apiRequest('POST', '/api/index/youtubeToText', {
            url,
        })
        if (!result.success) {
            throw new Error(result.error)
        }
        return result;
    } catch (error) {
        console.error('Webhook error:', error);
        return {
            success: false,
            error: error.message
        };
    }
}

export async function rewriteContent(id, style, custom) {
    try {
        const result = await apiRequest('POST', '/api/index/rewriteContent', {
            id,
            style,
            custom
        })
        if (!result.success) {
            throw new Error(result.error)
        }
        return result;
    } catch (error) {
        console.error('Webhook error:', error);
        return {
            success: false,
            error: error.message
        };
    }
}

export async function generateVoice(settings) {
    try {
        const result = await apiRequest('POST', '/api/index/generateVoice', settings)
        if (!result.success) {
            throw new Error(result.error)
        }
        return result;
    } catch (error) {
        console.error('Webhook error:', error);
        return {
            success: false,
            error: error.message
        };
    }
}

export async function cloneVoice(uploadFormData) {
    try {
        const result = await apiRequest('POST', '/api/index/cloneVoice', uploadFormData)
        if (!result.success) {
            throw new Error(result.error)
        }
        return result;
    } catch (error) {
        console.error('Webhook error:', error);
        return {
            success: false,
            error: error.message
        };
    }
}

export async function trickleListObjects(type, page, b) {
    
}

export async function trickleCreateObject(type, data) {

}

export async function trickleGetObject() {
    
}

export async function trickleUpdateObject(type, id, data) {

}

export async function trickleDeleteObject(type, id) {
    
}

export async function getUserCredits() {
    try {
        const userData = getUserData();
        if (!userData || !userData.id) {
            throw new Error('User not authenticated');
        }
        
        // Find the user's credit record
        const userCreditRecord = await apiRequest('POST', '/api/index/getUserCredits');
        
        if (userCreditRecord && userCreditRecord.success) {
            return {
                credits: userCreditRecord.data.value
            };
        } else {
            return {
                credits: 0
            };
        }
    } catch (error) {
        console.error('Failed to get user credits:', error);
        throw error;
    }
}

export async function apiRequest(method, url, params = {}) {
    try {
        const config = {
            method: method,
            url: (process.env.NODE_ENV === 'development' ? '' : 'https://tanaiapi.gogo2hk.com') + url,
            headers: {
                'Content-Type': method === 'POST' && params instanceof FormData ? 'multipart/form-data' : 'application/json',
                'token': getToken()
            }
        };

        if (method === 'POST' || method === 'PUT') {
            config.data = params instanceof FormData ? params : JSON.stringify(params);
        } else {
            config.params = params;
        }

        const response = await axios(config);
        if (response.status == 200) {
            if (response.data.code == 0) {
                return {
                    success: true,
                    data: response.data.data
                };
            } else if (response.data.code == 403) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/auth';
                return {
                    success: false,
                    error: response.error
                }
            } else {
                return {
                    success: false,
                    error: response.data.msg,
                    data: response.data.data
                };
            }
        } else {
            return {
                success: false,
                error: 'Status Code: ' + response.status
            };
        }
    } catch (error) {
        console.error('API request error:', error);
        return {
            success: false,
            error: error.message
        };
    }
}

export async function getMyVoices() {
    try {
        const result = await apiRequest('POST', '/api/index/getMyVoices')

        if (!result.success) {
            throw new Error(result.error);
        }
        
        return result.data.items;
    } catch (error) {
        console.error('Failed to get history:', error);
        throw error;
    }
}

export async function getPayment(id) {
    try {
        const result = await apiRequest('POST', '/api/index/getPayment', {
            id
        })

        if (!result.success) {
            throw new Error(result.error);
        }
        
        return result.data;
    } catch (error) {
        console.error('Failed to get history:', error);
        throw error;
    }
}
